import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useBulkCreateRewardsMutation, useCreateVipLevelRewardMutation } from '@services';

import { AppDispatch, setVipLevelReward } from '@store';

import {
  VipLevelRewardFormValues,
  VIP_LEVEL_REWARD_FORM_INITIAL_VALUES,
  VipLevelRewardForm,
} from '../../VipSettingsForms';

import { VipLevelRewardCreateModalProps } from './types';

export const VipLevelRewardCreateModal: FC<VipLevelRewardCreateModalProps> = ({
  isOpened,
  handleClose,
  vipLevelId,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [createVipLevelReward, { isLoading: isCreatingInProgress }] = useCreateVipLevelRewardMutation();
  const [createRewards] = useBulkCreateRewardsMutation();

  const handleCreateVipTaskItem = async ({ levelRewards, ...values }: VipLevelRewardFormValues) => {
    let rewardIds: string[] = [];

    if (levelRewards?.length) {
      rewardIds = await createRewards(levelRewards).unwrap();
    }
    const createdVipLevelReward = await createVipLevelReward({
      vipLevelId,
      rewardIds,
      ...values,
    }).unwrap();

    dispatch(setVipLevelReward(createdVipLevelReward));

    toast.success('Success: VIP level reward has been created!');

    handleClose();
  };

  return (
    <BaseModal
      headerTitle="Create VIP level reward"
      isOpened={isOpened}
      handleClose={handleClose}
      isFooterNeeded={false}
    >
      <VipLevelRewardForm
        initialValues={VIP_LEVEL_REWARD_FORM_INITIAL_VALUES}
        isSubmitting={isCreatingInProgress}
        onSubmit={handleCreateVipTaskItem}
      />
    </BaseModal>
  );
};
